import axios from 'axios';

import type {
  IUserFindTransferRequest,
  IUserFindTransferParams,
  IUserFindTransferResponse,
} from '@/app-package';

const findTransfer = async (params: IUserFindTransferParams) => {
  const config: IUserFindTransferRequest = {
    url: `transfer/${params.transferId}`,
    method: 'get',
  };

  const { data } = await axios.request<IUserFindTransferResponse>(config);

  return data;
};

type Transfer = IUserFindTransferResponse;

export { findTransfer, Transfer };
